<!--
    Summary:
        我的
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-banner">
    <div>
      <slot></slot>
    </div>
    <div class="title">
      <h1><slot name="title"></slot></h1>
    </div>
  </div>
</template>

<script>
  export default {
    name:"banner",
    data() {
      return {}
    },
    methods: {},
  }
</script>

<style scoped lang="scss">
  .v-banner {

    width: 100%;
    position: relative;
    text-align: left;

    img {
      width: 100%;
    }

    .title {
      top: 0;
      left: 10%;
      position: absolute;
      display: flex;
      align-items: center;
      height: 100%;

      h1 {
        font-size: 47px;
        letter-spacing: 1px;
        font-weight: 600;
        line-height: 60px;
        color: #fff;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, .4);
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/banner.vue